var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5C10.7072 21.5 9.60508 21.0493 8.69375 20.148C7.78258 19.2468 7.327 18.1526 7.327 16.8652V7.827C6.82183 7.827 6.39108 7.65033 6.03475 7.297C5.67825 6.94383 5.5 6.51467 5.5 6.0095V4.327C5.5 3.8245 5.67892 3.39442 6.03675 3.03675C6.39442 2.67892 6.8245 2.5 7.327 2.5H16.6635C17.1685 2.5 17.6008 2.67892 17.9605 3.03675C18.3202 3.39442 18.5 3.8245 18.5 4.327V6.0095C18.5 6.51467 18.3202 6.94383 17.9605 7.297C17.6008 7.65033 17.1685 7.827 16.6635 7.827V17.0095C16.625 18.2647 16.1535 19.3269 15.249 20.1962C14.3445 21.0654 13.2615 21.5 12 21.5ZM12 20C12.8787 20 13.6256 19.6971 14.2408 19.0913C14.8559 18.4856 15.1635 17.7436 15.1635 16.8652V16.4902H12.0673V14.9905H15.1635V12.5673H12.0673V11.0673H15.1635V7.827H8.827V16.8652C8.827 17.7436 9.1355 18.4856 9.7525 19.0913C10.3695 19.6971 11.1187 20 12 20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTube);
export default __webpack_public_path__ + "static/media/test-tube.48beb8cfcd0d6dd9a20448a1fc6812c1.svg";
export { ForwardRef as ReactComponent };